import React, { useState } from 'react';
import { X } from 'lucide-react';
import { galleryImages } from '../../data/mock';
import ResponsiveImage from '../ResponsiveImage';
import { handleImageError } from '../../lib/imageFallback';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="py-24 bg-[#F5F0E8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-wider text-[#C67C4E] uppercase mb-4">
            Gallery
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#1B4332] mb-6">
            A Taste of Our World
          </h2>
          <p className="text-lg text-[#636E72] max-w-2xl mx-auto">
            Explore our delicious dishes and warm atmosphere through our gallery.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className={`image-hover rounded-2xl overflow-hidden cursor-pointer shadow-md bg-[#F5EFE7] ${
                index === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
              onClick={() => setSelectedImage(image)}
            >
              <ResponsiveImage
                basePath={image.base}
                alt={image.alt}
                sizes={index === 0 ? '(max-width: 768px) 100vw, 800px' : '(max-width: 768px) 50vw, 400px'}
                className={`w-full object-cover object-center ${
                  index === 0 ? 'h-[300px] md:h-[500px]' : 'h-[200px] md:h-[240px]'
                }`}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox — uses the large WebP directly for max quality */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-[#C67C4E] transition-colors"
            onClick={() => setSelectedImage(null)}
            aria-label="Close lightbox"
          >
            <X size={32} />
          </button>
          <picture>
            <source type="image/webp" srcSet={`${selectedImage.base}-lg.webp`} />
            <img
              src={`${selectedImage.base}-lg.jpg`}
              alt={selectedImage.alt}
              decoding="async"
              onError={handleImageError}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </picture>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
